// extracted by mini-css-extract-plugin
export default {"banner":"ProfileBanner_banner__sgaTv","avatar":"ProfileBanner_avatar__8FauX","title":"ProfileBanner_title__nSQ3f","text":"ProfileBanner_text__fIe0W"};